const TRANSLATIONS = {
  english: {
    app_settings: 'Settings',
    app_profile: 'Profile',
    app_resume: 'Resume',
    app_projects: 'Projects',
    app_ai_auth: 'Auth Center',
    app_ai_chat: 'AI Chatting',
    app_profile_settings: 'Profile Settings',
    app_resume_settings: 'Resume Settings',
    app_projects_settings: 'Projects Settings',
    auth_out: 'Auth Out',
    auth_out_ready: 'Authenticated',
    auth_out_idle: 'Not authenticated',
    auth_out_help: 'Clears the browser session auth cache only. admin.json is not modified.',
    auth_out_action: 'Logout',
    auth_pass: 'Auth Pass',
    auth_pass_enabled: 'enabled',
    auth_pass_disabled: 'disabled',
    auth_pass_help: 'When enabled, administrator authentication is bypassed. When disabled, the auth modal is required.',
    language: 'Language',
    language_english: 'English',
    language_korean: 'Korean',
    language_help: 'Choose the language used for the desktop experience.',
    change_os: 'Change OS',
    change_os_help: 'Switch the desktop shell between MacUI, WinUI, and LinUI while keeping the same content and features.',
    os_mac: 'MacUI',
    os_win: 'WinUI',
    os_lin: 'LinUI',
    system_theme: 'System Theme',
    theme_light: 'Light',
    theme_dark: 'Dark',
    system_theme_help: 'Toggle the active desktop theme.',
    system_theme_selected_hint: 'Uploaded wallpapers will apply here.',
    landingpage_background_prefix: 'Landingpage',
    landingpage_background_suffix: 'ackground',
    landingpage_background_help: 'Landingpage is selected. Clicking an uploaded wallpaper will assign it to the lock screen background.',
    uploaded_wallpapers: 'Uploaded Wallpapers',
    upload_file: 'Upload File',
    icons: 'Shortcuts',
    add_icon: 'Add Shortcut',
    table_no: 'No.',
    table_shortcut_name: 'Shortcut Name',
    table_icon_emoji: 'Icon / Emoji',
    table_upload: 'Upload',
    table_file_name: 'File Name',
    table_link: 'Link',
    table_delete: 'Delete',
    menu_file: 'File',
    menu_edit: 'Edit',
    menu_view: 'View',
    menu_go: 'Go',
    menu_window: 'Window',
    menu_help: 'Help',
    cancel: 'Cancel',
    delete: 'Delete',
    upload: 'Upload',
    restore_suffix: 'restore'
  },
  korean: {
    app_settings: '설정',
    app_profile: '프로필',
    app_resume: '이력서',
    app_projects: '프로젝트목록',
    app_profile_settings: '프로필 설정',
    app_resume_settings: '이력서 설정',
    app_projects_settings: '프로젝트 목록 설정',
    auth_pass: '인증 회피',
    auth_pass_enabled: '활성화',
    auth_pass_disabled: '비활성화',
    auth_pass_help: '활성화되면 관리자 인증을 건너뛰고, 비활성화되면 인증 모달이 표시됩니다.',
    language: '사용언어',
    language_english: '영어',
    language_korean: '한국어',
    language_help: '데스크톱 환경에 사용할 언어를 선택합니다.',
    system_theme: '시스템 테마',
    theme_light: '라이트',
    theme_dark: '다크',
    system_theme_help: '현재 데스크톱 테마를 전환합니다.',
    system_theme_selected_hint: '업로드한 배경화면이 여기에 적용됩니다.',
    landingpage_background_prefix: '랜딩 페이지',
    landingpage_background_suffix: '배경화면',
    landingpage_background_help: '랜딩 페이지가 선택되었습니다. 업로드한 배경화면을 클릭하면 잠금 화면 배경으로 적용됩니다.',
    uploaded_wallpapers: '업로드한 배경화면목록',
    upload_file: '파일 업로드',
    icons: '바로가기 목록',
    add_icon: '바로가기 추가',
    table_no: '순번',
    table_shortcut_name: '바로가기 이름',
    table_icon_emoji: '아이콘 / 이모지',
    table_upload: '파일 업로드',
    table_file_name: '파일명',
    table_link: '접속주소',
    table_delete: '삭제',
    menu_file: '파일',
    menu_edit: '수정',
    menu_view: '보기',
    menu_go: '실행',
    menu_window: '윈도우',
    menu_help: '도움',
    delete: '삭제',
    upload: '파일 업로드',
    restore_suffix: '복원'
  }
};

export const normalizeLanguage = (language) => (language === 'korean' ? 'korean' : 'english');

export const t = (language, key) => {
  const locale = normalizeLanguage(language);
  return TRANSLATIONS[locale][key] || TRANSLATIONS.english[key] || key;
};

export const getLocalizedAppLabel = (id, fallbackLabel, language) => {
  const keyById = {
    settings: 'app_settings',
    profile: 'app_profile',
    resume: 'app_resume',
    projects: 'app_projects',
    'ai-auth': 'app_ai_auth',
    'ai-chat': 'app_ai_chat',
    'profile-settings': 'app_profile_settings',
    'resume-settings': 'app_resume_settings',
    'projects-settings': 'app_projects_settings'
  };

  const translationKey = keyById[id];
  return translationKey ? t(language, translationKey) : fallbackLabel;
};

export const getLocalizedShortcutLabel = (icon, language) => {
  if (!icon) {
    return '';
  }

  const builtInLabel = getLocalizedAppLabel(icon.id, icon.label, language);
  if (builtInLabel !== icon.label) {
    return builtInLabel;
  }

  const locale = normalizeLanguage(language);
  const alternateLocale = locale === 'english' ? 'korean' : 'english';
  const localizedLabels = icon.localizedLabels || {};
  const primaryLabel = typeof localizedLabels[locale] === 'string' ? localizedLabels[locale] : '';
  const alternateLabel = typeof localizedLabels[alternateLocale] === 'string' ? localizedLabels[alternateLocale] : '';

  return primaryLabel || alternateLabel || icon.label || '';
};

export const formatTopBarClock = (date, language) => {
  if (normalizeLanguage(language) === 'korean') {
    const weekday = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'][date.getDay()];
    const hours24 = date.getHours();
    const period = hours24 < 12 ? '오전' : '오후';
    const hour12 = hours24 % 12 || 12;
    const minutes = `${date.getMinutes()}`.padStart(2, '0');

    return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${weekday}, ${period} ${hour12}시 ${minutes}분`;
  }

  const dateText = date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
  const timeText = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  return `${dateText}   ${timeText}`;
};

export const formatLockScreenDate = (date, language) => {
  const locale = normalizeLanguage(language) === 'korean' ? 'ko-KR' : 'en-US';

  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }).format(date);
};

export const formatLockScreenTime = (date, language) => {
  const locale = normalizeLanguage(language) === 'korean' ? 'ko-KR' : 'en-US';

  return new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(date);
};
